import React from "react";
import { useEffect, useState, useRef, useLayoutEffect } from "react";
import "./FaultFirstPageCustom_bus.css";
import * as $ from "jquery";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

import useHttp from "../../../../hook/use-http";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates";
import NoData from "../../Driveanalysis_Bus/NoData_Bus";
import COmpBiDirTest from "./FaultSecondPageChartsBidirRender_Bus";
import ChartLoader from "../../Driveanalysis_Bus/ChartLoader";

export default function FaultSecondPageBarCharts(props) {
  let { title, template_id, show, soarting, gloablfilter, IND } = props;
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [defaultNav, setDefaultNav] = useState("BCS-1");
  const [dataMain, setDataMain] = useState([]);
  const [imb, setImb] = useState(false);
  const [LineContainerBodyBD, setCssLineCont] = useState({ height: "268px" }); //width: "565px",
  // #ffa344 #358696
  const [topping, setTopping] = useState("Fault");
  const [toShow, setToShow] = useState(false);
  const [toCalculateFault, setToCalculateFault] = useState(0);
  const [responceDataImbDataImb, setresponceDataImbData] = useState([]);
  const [single_name, setsingle_name] = useState([]);
  const [activePage, setActivePage] = useState(1);

  let responceDataImbData = [];
  const onRadioChange = (e) => {
    setTopping(e.target.value);
  };

  const responceData = (data) => {
    let dataArray = [];
    let maleAdd = 0;
    let femaleAdd = toCalculateFault;
    data.forEach((obj1, index) => {
      maleAdd += obj1.duration.value;
    });
    let single_name_array = [];
    data.forEach((obj1, index) => {
      let male = (obj1.duration.value / maleAdd) * 100;
      let female = (obj1.Total_vehicle_count.value / femaleAdd) * 100;
      dataArray.push({
        age: obj1.key.spnname.toUpperCase(),
        male: -male,
        female: female,
        orgLevalMale: obj1.duration.value.toFixed(0).toString(),
        orgLevalFemale: obj1.Total_vehicle_count.value.toString(),
        signal_nm: obj1.key.spnname,
        signal_desc: obj1.key.Description,
        signal_val: obj1.key.spnvalue.toString(),
      });
      single_name_array.push(obj1.key.spnname);
    });

    setsingle_name(single_name_array);
    for (let i = 0; i < dataArray.length; i++) {
      let count = 0;
      for (let j = i + 1; j < dataArray.length; j++) {
        if (dataArray[i].age === dataArray[j].age) {
          dataArray[j].age = dataArray[j].age + "_" + dataArray[j].signal_val;
          count = 1;
        }
      }
      if (count) {
        dataArray[i].age = dataArray[i].age + "_" + dataArray[i].signal_val;
      }
    }
    dataArray.sort((a, b) => parseFloat(a.male) - parseFloat(b.male));
    setDataMain(dataArray);
  };
  const responceDataImb = (data) => {
    let dataArray = [];
    let maleAdd = 0;
    let femaleAdd = 0;
    data.forEach((obj1, index) => {
      maleAdd += obj1.duration;
      femaleAdd += obj1.vehicle_count;
    });
    data.forEach((obj1, index) => {

      let male = (obj1.duration / maleAdd) * 100;
      let female = (obj1.vehicle_count / vehiclewithdtc) * 100;
      dataArray.push({
        age: obj1.spnname.toUpperCase(),
        male: -male,
        female: female,
        orgLevalMale: obj1.duration.toFixed(0).toString(),
        orgLevalFemale: obj1.vehicle_count.toString(),
        signal_nm: obj1.spnname,
      });
    });

    for (let i = 0; i < dataArray.length; i++) {
      let count = 0;
      for (let j = i + 1; j < dataArray.length; j++) {
        if (dataArray[i].age === dataArray[j].age) {
          dataArray[j].age = dataArray[j].age + "_" + dataArray[j].signal_val;
          count = 1;
        }
      }
      if (count) {
        dataArray[i].age = dataArray[i].age + "_" + dataArray[i].signal_val;
      }
    }

    dataArray.sort((a, b) => parseFloat(a.male) - parseFloat(b.male));
    setDataMain(dataArray);
  };
  function addECU(dataArr, chngKey) {
    const mainECU = ["BCS", "BMS", "DCDC", "MCU", "OBC", "VCU"];
    mainECU.forEach((element) => {
      var index = dataArr.findIndex((x) => x.key.ECU == element);
      index === -1 &&
        dataArr.push({
          key: { ECU: element },
          doc_count: 0,
          [`${chngKey}`]: { value: 0 },
        });
    });
    let dataA = dataArr.sort(function (a, b) {
      return a.key.ECU.localeCompare(b.key.ECU);
    });
    return dataA;
  }

  const responceBarData = (data) => {
    const ecu = addECU(data, "vehicle_count");
    const foodBar = ecu.find((item) => item.key.ECU === defaultNav);
    const bmsDataCount = ecu.find((item) => item.key.ECU === "BMS");
    if (defaultNav === "sp")
      setToCalculateFault(bmsDataCount.vehicle_count.value);
    else setToCalculateFault(foodBar.vehicle_count.value);
  };

  const appyBarData = (data) => {
    const ecu = addECU(data, "vehicle_count");

    const foodBar = ecu.find((item) => item.key.ECU === defaultNav);
    setToCalculateFault(foodBar.vehicle_count.value);
  };
  const appyDtcData = (data) => {
    setToCalculateFault(data.vehicle_count.value);
  };
  let responceDataImbDataA = [];
  let responceDataImbDataB = [];
  let responceDataImbDataC = [];
  let responceDataImbDataD = [];
  const responceDataImb_A = (dataimba) => {
    const data = dataimba[0];
    responceDataImbDataA.push({
      duration: data.duration_A.value,
      vehicle_count: data.vehicle_count.value,
      spnname: "A_pack",
    });
    responceDataImbData.push(responceDataImbDataA[0]);
  };

  const responceDataImb_B = (dataimbb) => {
    const data = dataimbb[0];
    responceDataImbDataB.push({
      duration: data.duration_B.value,
      vehicle_count: data.vehicle_count.value,
      spnname: "B_pack",
    });
    responceDataImbData.push(responceDataImbDataB[0]);
  };

  const responceDataImb_C = (dataimbc) => {
    const data = dataimbc[0];
    responceDataImbDataC.push({
      duration: data.duration_C.value,
      vehicle_count: data.vehicle_count.value,
      spnname: "C_pack",
    });

    responceDataImbData.push(responceDataImbDataC[0]);
  };
  const responceDataImb_D = (dataimbd) => {
    const data = dataimbd[0];

    setToCalculateFault(data.vehicle_count.value);
    responceDataImbDataD.push({
      duration: data.duration_D.value,
      vehicle_count: data.vehicle_count.value,
      spnname: "D_pack",
    });
    responceDataImbData.push(responceDataImbDataD[0]);

    setresponceDataImbData(responceDataImbData);
    responceDataImb(responceDataImbData);
  };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "faultfirstpage_bus/faulwithdtc_bus",
        body: { filterdata: gloablfilter },
      },
      vehicleWithDtc
    );
    fetchData(
      {
        url: API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusImb_A",
        body: { filterdata: gloablfilter, IND, defaultNav: defaultNav },
      },
      responceDataImb_A
    );
    fetchData(
      {
        url: API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusImb_B",
        body: { filterdata: gloablfilter, IND, defaultNav: defaultNav },
      },
      responceDataImb_B
    );
    fetchData(
      {
        url: API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusImb_C",
        body: { filterdata: gloablfilter, IND, defaultNav: defaultNav },
      },
      responceDataImb_C
    );
    fetchData(
      {
        url: API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusImb_D",
        body: { filterdata: gloablfilter, IND, defaultNav: defaultNav },
      },
      responceDataImb_D
    );
  }, [gloablfilter]);

  useEffect(() => {
    if (topping === "Fault") {
      fetchData(
        {
          url: API_URL_MAIN + "faultfirstpage_bus/faultanalysis_bus",
          body: { filterdata: gloablfilter, IND },
        },
        responceBarData
      );
    } else if (topping === "Alarm") {
      fetchData(
        {
          url: API_URL_MAIN + "faultfirstpage_bus/alarmanalysis_bus",
          body: { filterdata: gloablfilter, IND },
        },
        appyBarData
      );
    }

    if (topping === "Fault" || topping === "Alarm") {

      if (topping === "Alarm" && defaultNav === "sp") {
        $("#sp").removeClass("active");
        $("#BCS-1").addClass("active");
        setDefaultNav("BCS-1");
        setActivePage(1);
        fetchData(
          {
            url: API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBus" + topping,
            body: { filterdata: gloablfilter, IND, defaultNav: "BCS-1" },
          },
          responceData
        );
      } else {
        fetchData(
          {
            url: API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBus" + topping,
            body: { filterdata: gloablfilter, IND, defaultNav: defaultNav },
          },
          responceData
        );
        setActivePage(2);
      }
    }
    if (topping === "DTC") {
      responceDataImb(responceDataImbDataImb);
      setDefaultNav("BCS-1");
    }

  }, [topping, defaultNav, toCalculateFault, gloablfilter, responceDataImbDataImb]);

  const [vehiclewithdtc, setVehicleWithDtc] = useState(0);
  const vehicleWithDtc = (data) => {
    setVehicleWithDtc(data[0].vehicle_count.value);
  };

  function getNavTab(e, name) {
    setDefaultNav(name);
  }

  return (
    <div className="col-md-12 col-lg-6 col-sm-12 mb-3">
      <div className="v-title chartbox3">
        <div className="row mb-3 titlebg_bus_fault">
          <div className="col-md-12 col-sm-6 col-lg-6">
            <div className="text-fit">Fault/Alarm/Curr.Imbalance List</div>
          </div>
          <div className="col-md-12 col-sm-6 col-lg-6 py-1">
            <div className="form-check form-check-inline bus">
              <input
                className="form-check-input"
                type="radio"
                name="inlineRadioOptions"
                id="Fault"
                value="Fault"
                checked={topping === "Fault"}
                onChange={onRadioChange}
              />
              <label className="form-check-label" htmlFor="inlineRadio1">
                Fault
              </label>
            </div>
            <div className="form-check form-check-inline bus">
              <input
                className="form-check-input"
                type="radio"
                name="inlineRadioOptions"
                id="Alarm"
                value="Alarm"
                checked={topping === "Alarm"}
                onChange={onRadioChange}
              />
              <label className="form-check-label" htmlFor="inlineRadio2">
                Alarm
              </label>
            </div>
            <div className="form-check form-check-inline bus">
              <input
                className="form-check-input "
                type="radio"
                name="inlineRadioOptions"
                id="DTC"
                value="DTC"
                checked={topping === "DTC"}
                onChange={onRadioChange}
              />
              <label className="form-check-label" htmlFor="inlineRadio2">
                Curr.Imbalance
              </label>
            </div>
          </div>
        </div>
        {topping === "Fault" || topping === "Alarm" ? (
          <div className="chartHGT">
            <div className="mt-2 mb-2">
              <div className="mt-3">
                <ul
                  className="nav nav-tabs"
                  role="tablist"
                  style={{ marginBottom: "5px" }}
                >
                  <li className="nav-item">
                    <a
                      className={
                        activePage === 1 ? "nav-link" : "nav-link active"
                      }
                      data-bs-toggle="tab"
                      href="#BCS-1"
                      onClick={(e) => getNavTab(e, "BCS-1")}
                    >
                      BCS-1
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-bs-toggle="tab"
                      href="#BCS-2"
                      onClick={(e) => getNavTab(e, "BCS-2")}
                    >
                      BCS-2
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-bs-toggle="tab"
                      href="#MCU"
                      onClick={(e) => getNavTab(e, "MCU")}
                    >
                      MCU
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-bs-toggle="tab"
                      href="#VCU"
                      onClick={(e) => getNavTab(e, "VCU")}
                    >
                      VCU
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-bs-toggle="tab"
                      href="#Aux-1"
                      onClick={(e) => getNavTab(e, "Aux-1")}
                    >
                      Aux-1
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-bs-toggle="tab"
                      href="#Aux-2"
                      onClick={(e) => getNavTab(e, "Aux-2")}
                    >
                      Aux-2
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-bs-toggle="tab"
                      href="#BMS"
                      onClick={(e) => getNavTab(e, "BMS")}
                    >
                      BMS
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-bs-toggle="tab"
                      href="#HVAC"
                      onClick={(e) => getNavTab(e, "HVAC")}
                    >
                      HVAC
                    </a>
                  </li>
                  {topping === "Fault" ? (
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-bs-toggle="tab"
                        href="#sp"
                        onClick={(e) => getNavTab(e, "sp")}
                      >
                        Critical
                      </a>
                    </li>
                  ) : (
                    <></>
                  )}
                </ul>
                <div className="tab-content">
                  <div className="row" style={{ textAlign: "right" }}>
                    <dl style={{ marginBottom: "0rem", paddingRight: "3rem" }}>
                      <dt className="red_bus"></dt>
                      <dd>Time Duration (mins)</dd>
                      <dt
                        className="yellow_bus"
                        style={{ marginLeft: "5px" }}
                      ></dt>
                      <dd>Vehicle Count</dd>
                    </dl>
                  </div>
                  <div id="BCS-1" className="tab-pane active">
                    <br />
                    <div
                      style={{
                        width: "auto",
                        maxWidth: "auto",
                        overflowX: "scroll",
                        overflowY: "scroll",
                      }}
                    >
                      <div style={LineContainerBodyBD}>
                        {isLoading ? (
                          <ChartLoader />
                        ) : dataMain.length > 0 ? (
                          <COmpBiDirTest
                            dataMain={dataMain}
                            id={"chartdivBCS-1"}
                            type={topping}
                            unit={defaultNav}
                            gloablfilter={gloablfilter}
                            signal_name={single_name}
                          />
                        ) : (
                          <NoData />
                        )}
                      </div>
                    </div>
                  </div>
                  <div id="BCS-2" className="tab-pane">
                    <br />
                    <div
                      style={{
                        width: "auto",
                        maxWidth: "auto",
                        overflowX: "scroll",
                        overflowY: "scroll",
                      }}
                    >
                      <div style={LineContainerBodyBD}>
                        {isLoading ? (
                          <ChartLoader />
                        ) : dataMain.length > 0 ? (
                          <COmpBiDirTest
                            dataMain={dataMain}
                            id={"chartdivBCS-2"}
                            type={topping}
                            unit={defaultNav}
                            gloablfilter={gloablfilter}
                            signal_name={single_name}
                          />
                        ) : (
                          <NoData />
                        )}
                      </div>
                    </div>
                  </div>

                  <div id="MCU" className="container tab-pane fade">
                    <br />
                    <div
                      style={{
                        width: "auto",
                        maxWidth: "auto",
                        overflowX: "scroll",
                        overflowY: "scroll",
                      }}
                    >
                      <div style={LineContainerBodyBD}>
                        {isLoading ? (
                          <ChartLoader />
                        ) : dataMain.length > 0 ? (
                          <COmpBiDirTest
                            dataMain={dataMain}
                            id={"chartdivMCU"}
                            type={topping}
                            unit={defaultNav}
                            gloablfilter={gloablfilter}
                            signal_name={single_name}
                          />
                        ) : (
                          <NoData />
                        )}
                      </div>
                    </div>
                  </div>
                  <div id="VCU" className="container tab-pane fade">
                    <br />
                    <div
                      style={{
                        width: "auto",
                        maxWidth: "auto",
                        overflowX: "scroll",
                        overflowY: "scroll",
                      }}
                    >
                      <div style={LineContainerBodyBD}>
                        {isLoading ? (
                          <ChartLoader />
                        ) : dataMain.length > 0 ? (
                          <COmpBiDirTest
                            dataMain={dataMain}
                            id={"chartdivVCU"}
                            type={topping}
                            unit={defaultNav}
                            gloablfilter={gloablfilter}
                            signal_name={single_name}
                          />
                        ) : (
                          <NoData />
                        )}
                      </div>
                    </div>
                  </div>
                  <div id="Aux-1" className="container tab-pane fade">
                    <br />
                    <div
                      style={{
                        width: "auto",
                        maxWidth: "auto",
                        overflowX: "scroll",
                        overflowY: "scroll",
                      }}
                    >
                      <div style={LineContainerBodyBD}>
                        {isLoading ? (
                          <ChartLoader />
                        ) : dataMain.length > 0 ? (
                          <COmpBiDirTest
                            dataMain={dataMain}
                            id={"chartdivAux-1"}
                            type={topping}
                            unit={defaultNav}
                            gloablfilter={gloablfilter}
                            signal_name={single_name}
                          />
                        ) : (
                          <NoData />
                        )}
                      </div>
                    </div>
                  </div>
                  <div id="Aux-2" className="container tab-pane fade">
                    <br />
                    <div
                      style={{
                        width: "auto",
                        maxWidth: "auto",
                        overflowX: "scroll",
                        overflowY: "scroll",
                      }}
                    >
                      <div style={LineContainerBodyBD}>
                        {isLoading ? (
                          <ChartLoader />
                        ) : dataMain.length > 0 ? (
                          <COmpBiDirTest
                            dataMain={dataMain}
                            id={"chartdivAux-2"}
                            type={topping}
                            unit={defaultNav}
                            gloablfilter={gloablfilter}
                            signal_name={single_name}
                          />
                        ) : (
                          <NoData />
                        )}
                      </div>
                    </div>
                  </div>
                  <div id="BMS" className="container tab-pane fade">
                    <br />
                    <div
                      style={{
                        width: "auto",
                        maxWidth: "auto",
                        overflowX: "scroll",
                        overflowY: "scroll",
                      }}
                    >
                      <div style={LineContainerBodyBD}>
                        {isLoading ? (
                          <ChartLoader />
                        ) : dataMain.length > 0 ? (
                          <COmpBiDirTest
                            dataMain={dataMain}
                            id={"chartdivBMS"}
                            type={topping}
                            unit={defaultNav}
                            gloablfilter={gloablfilter}
                            signal_name={single_name}
                          />
                        ) : (
                          <NoData />
                        )}
                      </div>
                    </div>
                  </div>
                  <div id="HVAC" className="container tab-pane fade">
                    <br />
                    <div
                      style={{
                        width: "auto",
                        maxWidth: "auto",
                        overflowX: "scroll",
                        overflowY: "scroll",
                      }}
                    >
                      <div style={LineContainerBodyBD}>
                        {isLoading ? (
                          <ChartLoader />
                        ) : dataMain.length > 0 ? (
                          <COmpBiDirTest
                            dataMain={dataMain}
                            id={"chartdivHVAC"}
                            type={topping}
                            unit={defaultNav}
                            gloablfilter={gloablfilter}
                            signal_name={single_name}
                          />
                        ) : (
                          <NoData />
                        )}
                      </div>
                    </div>
                  </div>
                  {topping === "Fault" ? (
                    <div id="sp" className="container tab-pane fade">
                      <br />
                      <div
                        style={{
                          width: "auto",
                          maxWidth: "auto",
                          overflowX: "scroll",
                          overflowY: "scroll",
                        }}
                      >
                        <div style={LineContainerBodyBD}>
                          {isLoading ? (
                            <ChartLoader />
                          ) : dataMain.length > 0 ? (
                            <COmpBiDirTest
                              dataMain={dataMain}
                              id={"chartdivsp"}
                              type={topping}
                              unit={defaultNav}
                              gloablfilter={gloablfilter}
                              signal_name={single_name}
                            />
                          ) : (
                            <NoData />
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        {topping === "DTC" ? (
          <div className="chartHGT">
            <div className="mt-2 mb-2">
              <div className="mt-3">
                <ul
                  className="nav nav-tabs"
                  role="tablist"
                  style={{ marginBottom: "5px" }}
                >
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      data-bs-toggle="tab"
                      href="#Imb"
                      onClick={(e) => getNavTab(e, "Imb")}
                    >
                      Imbalance
                    </a>
                  </li>
                </ul>
                <div className="tab-content">
                  <div className="row" style={{ textAlign: "right" }}>
                    <dl style={{ marginBottom: "0rem", paddingRight: "3rem" }}>
                      <dt className="red_bus"></dt>
                      <dd>Time Duration (mins)</dd>
                      <dt
                        className="yellow_bus"
                        style={{ marginLeft: "5px" }}
                      ></dt>
                      <dd>Vehicle Count</dd>
                    </dl>
                  </div>
                  <div id="Imb" className="tab-pane active">
                    <br />
                    <div
                      style={{
                        width: "auto",
                        maxWidth: "auto",
                        overflowX: "scroll",
                        overflowY: "scroll",
                      }}
                    >
                      <div style={LineContainerBodyBD}>
                        {isLoading ? (
                          <ChartLoader />
                        ) : dataMain.length > 0 ? (
                          <COmpBiDirTest
                            dataMain={dataMain}
                            id={"chartdivImb"}
                            type={topping}
                            unit={defaultNav}
                            gloablfilter={gloablfilter}
                            signal_name={single_name}
                          />
                        ) : (
                          <NoData />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
